<div class="layout-row height-100vh bg-w">
    <div class="layout-column c-center area-100 bg-highlight1">
      <div [formGroup]="formGroup" class="area-50 ml-10">
        <p>ユーザー認証</p>
        <input class="mt-10" formControlName="authenticationCode" type="number" maxlength="4" placeholder="認証コードを入力してください" />
        <button class="btn-main area-100px mt-20"
          #tooltip="matTooltip"
          matTooltip
          matTooltipPosition="above"
          (click)="authenticateUser(tooltip)">
          Sign up
        </button>
      </div>
    </div>
  </div>
  